import React from "react"
import '../css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import maintenanceIcon from '../icons/maintenance-icon.svg';
function TrackingPage() {
    return (
      <div className="main_container mybackground">
      <h1 className="title">Página em Manutenção</h1>
      <div className="container padding-bottom-3x mb-1">
        <div className="card mb-3">
          <div className="p-4 text-center text-white text-lg bg-dark rounded-top">
            <span className="text-medium">Estamos em manutenção para melhor atendê-los e em breve seu pedido será atualizado</span>
          </div>
          <div className="card-body">
            <div className="text-center">
              <img src={maintenanceIcon} alt="Ícone de Manutenção" style={{ width: '100px', height: '100px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
export default TrackingPage;